import { Order } from '@/models/Order';

export class OrderItem extends Order {
  protected $name: string = 'OrderItem';
  protected $endpoint: string = '/orders/{id}/relationships/order-items';
  protected $fillable: string[] = [
    'product',
    'discount',
    'discount_type',
  ];

  public product?: Product;
  public evaluation?: any;
  public returned?: boolean;
  public discount?: string;
  public discount_type?: string;
  public quantity?: number;
  public price?: number;
  public returned_at: any;


  public order(order: Order | string) {
    if(typeof order !== 'string') {
      order = order.id || '';
    }

    this.$endpoint = `/orders/${order}/relationships/order-items`;

    return this;
  }

  deleteOrderItem(orderId: string, itemId: string) {
    const url =  `/orders/${orderId}/relationships/order-items/${itemId}`;
    return this.request('delete', url);
  }

  public updateOrderItem(orderId: string, itemId: string, payload: object) {
    const url = `orders/${orderId}/relationships/order-items/${itemId}`;

    return this.request('patch', url, payload);
  }

  public resolvePrimaryKey(): string {
    return '';
  }
}

interface Product {
  id?: string;
  name?: string;
  brand?: string;
  discount?: string;
  size?: string;
  color?: string;
  supplier?: string;
  stock_on_hand?: string;
  retail_price?: number;
  image_url?: string;
  created_at?: string;
  updated_at?: string;
}
